import { useSyncExternalStore } from 'react';
import { getDoiSettings, setDoiSettings, subscribeDoiSettings } from '../lib/doi-settings';

/** { mask, threshold, setMask, setThreshold } — the global DOI mask settings (lib/doi-settings.js). */
export default function useDoiSettings() {
  const s = useSyncExternalStore(subscribeDoiSettings, getDoiSettings, getDoiSettings);
  return {
    ...s,
    setMask: (mask) => setDoiSettings({ mask }),
    setThreshold: (threshold) => setDoiSettings({ threshold }),
  };
}
